var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenEditIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.15 1.85645L0.5 7.50644L0.5 9.50644H2.5L8.15 3.85644L6.15 1.85645Z",
    fill: "#07AFA6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8499 2.10692L8.8499 3.10692L6.8999 1.15692L7.8999 0.156922C8.0499 -0.0430781 8.3499 -0.043078 8.5499 0.106922L9.1999 0.756922L9.8499 1.40692C10.0499 1.65692 10.0499 1.95692 9.8499 2.10692Z",
    fill: "#07AFA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenEditIcon);
export default __webpack_public_path__ + "static/media/green_edit_icon.70b8f9337255f44bc0b909317c9a9565.svg";
export { ForwardRef as ReactComponent };